import { Box, Dialog, DialogContent, IconButton, InputAdornment, TextField } from '@mui/material';
import { Close, Search } from '@mui/icons-material';
import { useSearch } from './hooks';
import { Adotment, SearchTable } from './components';

type TypeProps = {
  isMultiplePartners: boolean;
  partners?: { label: string; id: string }[];
};

export const SearchBar = ({ isMultiplePartners, partners }: TypeProps) => {
  const {
    isMobile,
    tabIndex,
    handleChangeTab,
    searchQuery,
    debouncedSearch,
    isOpen,
    onOpen,
    onClose,
    handleChange,
    handleOpenModalWithText,
    isInitLoading,
    isFetching,
    output,
    isNoFound,
    offset,
    setOffset,
    isFlagOfInterest,
    setIsFlagOfInterest,
    isLeadAuditor,
  } = useSearch();

  return (
    <Box>
      {isMobile ? (
        <IconButton onClick={onOpen}>
          <Search />
        </IconButton>
      ) : (
        <TextField
          value={searchQuery}
          size='small'
          placeholder='Search'
          InputProps={{
            sx: { background: 'white' },
            startAdornment: (
              <InputAdornment position='start'>
                <Search />
              </InputAdornment>
            ),
          }}
          onChange={handleChange}
          onClick={handleOpenModalWithText}
        />
      )}
      <Dialog sx={{ padding: 4 }} fullScreen open={isOpen} onClose={onClose} disableRestoreFocus>
        <DialogContent sx={{ padding: 4 }}>
          <Box display='flex' alignItems='center' gap={4} mb={4.5}>
            <TextField
              fullWidth
              label='Search'
              value={searchQuery}
              onChange={handleChange}
              autoFocus
              InputProps={{
                sx: { overflow: 'hidden' },
                endAdornment: isNoFound && <Adotment length={searchQuery.length} />,
              }}
            />

            <IconButton onClick={onClose}>
              <Close sx={{ color: (theme) => theme.palette.grey[700] }} />
            </IconButton>
          </Box>
          <SearchTable
            searchText={debouncedSearch}
            page={offset}
            tabIndex={tabIndex}
            handleChange={handleChangeTab}
            isLoading={isFetching}
            isInitLoad={isInitLoading}
            data={output}
            partners={partners}
            isLeadAuditor={isLeadAuditor}
            isMultiplePartners={isMultiplePartners}
            isNoFound={isNoFound}
            offset={offset}
            setOffset={setOffset}
            isInterest={isFlagOfInterest}
            setIsInterest={setIsFlagOfInterest}
            closeModal={onClose}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};
